import { HeartIcon } from '@heroicons/react/solid';

const Footer = (): JSX.Element => {
  return (
    <div className="flex justify-center text-gray-400 text-xs items-center p-2">
      <span>
        Powered by{' '}
        <a href="https://onistudio.net" target="_blank" rel="noreferrer">
          onistudio.net
        </a>
      </span>
      <HeartIcon className="text-red-400 w-4 h-4 ml-1" />
    </div>
  );
};
export default Footer;
